var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonalizeImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70835 8.47221C8.55212 8.47221 9.23613 7.7882 9.23613 6.94443C9.23613 6.10067 8.55212 5.41666 7.70835 5.41666C6.86458 5.41666 6.18057 6.10067 6.18057 6.94443C6.18057 7.7882 6.86458 8.47221 7.70835 8.47221Z",
    stroke: "#505152",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7639 2.3611H7.70834C3.88889 2.3611 2.36111 3.88888 2.36111 7.70832V12.2917C2.36111 16.1111 3.88889 17.6389 7.70834 17.6389H12.2917C16.1111 17.6389 17.6389 16.1111 17.6389 12.2917V8.47221",
    stroke: "#505152",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4542 2.8118L12.6813 5.58471C12.5743 5.69166 12.4674 5.89791 12.4521 6.05069L12.2993 7.11249C12.2458 7.49444 12.5132 7.7618 12.8952 7.70832L13.957 7.55555C14.1021 7.53263 14.316 7.43332 14.4229 7.32638L17.1958 4.55346C17.6771 4.07221 17.8986 3.52221 17.1958 2.81944C16.4854 2.10138 15.9354 2.33055 15.4542 2.8118Z",
    stroke: "#505152",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0569 3.20903C15.2938 4.04931 15.9507 4.70625 16.791 4.94306",
    stroke: "#505152",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87296 15.309L6.63893 12.7805C7.2424 12.3757 8.11323 12.4215 8.65559 12.8875L8.90768 13.109C9.50351 13.6208 10.466 13.6208 11.0618 13.109L14.2396 10.3819C14.8355 9.87013 15.798 9.87013 16.3938 10.3819L17.6389 11.4514",
    stroke: "#505152",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalizeImage);
export default __webpack_public_path__ + "static/media/personalize-image.a49cf091f0b4d7eb0817fe3b364208ab.svg";
export { ForwardRef as ReactComponent };